import React from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useResources } from 'src/resources';
import { useAppSelector } from 'src/store/reducers';
import { getDocumentGuid } from 'src/store/selectors/microwebSelectors';

import type { FieldValues, UseFormReturn } from 'react-hook-form';
import type { HNSkjemaFrontend } from 'src/types/Resources';

import Button from '@helsenorge/designsystem-react/components/Button';
import StepButtons from '@helsenorge/designsystem-react/components/StepButtons';

import { getFormData } from '@helsenorge/refero';
import { useMicrowebStepData } from '@helsenorge/step/hooks/useMicrowebStepData';

interface Props {
  reactHookFormMethods: UseFormReturn<FieldValues, unknown>;
  trackFormError: () => void;
  erSendOgLagreKnapperDisabled: boolean;
  displaySaveIcon: boolean;
  onSubmit: () => void;
}

const FormButtonsMicrowebStep = ({
  reactHookFormMethods,
  trackFormError,
  erSendOgLagreKnapperDisabled,
  onSubmit,
}: Props): React.JSX.Element => {
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);
  const { avbryturl, avbrytarialabel, hidebackbutton } = useAppSelector(state => state.microweb);
  const { navigateBack } = useMicrowebStepData();
  const documentGuid = useAppSelector(getDocumentGuid);
  const formData = useAppSelector(getFormData);

  const onBackButtonClicked = (): void => {
    navigateBack({
      dokumentGuid: documentGuid,
      skjemadata: JSON.stringify(formData),
    });
  };
  const onCancelButtonClicked = (): void => {
    navigateBack(undefined);
  };
  const onSubmitSuccess = (): void => {
    onSubmit();
  };
  const onSubmitButtonClicked = (): void => {
    const handleSubmit = reactHookFormMethods.handleSubmit(
      () => onSubmitSuccess(),
      () => trackFormError()
    );
    handleSubmit();
  };

  return (
    <div className="formButtonsBackground" data-testid="form-buttons-microweb-step">
      <StepButtons
        backButton={
          hidebackbutton ? <></> : <Button onClick={onBackButtonClicked}>{resources?.microwebstep_navigasjon_tilbake_button}</Button>
        }
        cancelButton={
          avbryturl ? (
            <Button variant="borderless" href={avbryturl} htmlMarkup="a" aria-label={avbrytarialabel} testId="cancel-button">
              {resources?.microwebstep_navigasjon_avbryt_button}
            </Button>
          ) : (
            <Button onClick={onCancelButtonClicked}>{resources?.microwebstep_navigasjon_avbryt_button}</Button>
          )
        }
        forwardButton={
          <Button disabled={erSendOgLagreKnapperDisabled} onClick={onSubmitButtonClicked}>
            {resources?.microwebstep_navigasjon_neste_button}
          </Button>
        }
      />
    </div>
  );
};

export default FormButtonsMicrowebStep;
